module.exports = __webpack_public_path__ + "static/img/22.33fb638.png";


//////////////////
// WEBPACK FOOTER
// ./img/yj/22.png
// module id = daiI
// module chunks = 1